var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLockAlt = function SvgLockAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.0714 10.75H18.1071V7.9375C18.1071 4.66406 15.367 2 12 2C8.63304 2 5.89286 4.66406 5.89286 7.9375V10.75H4.92857C3.86384 10.75 3 11.5898 3 12.625V20.125C3 21.1602 3.86384 22 4.92857 22H19.0714C20.1362 22 21 21.1602 21 20.125V12.625C21 11.5898 20.1362 10.75 19.0714 10.75ZM13.6071 17.3125C13.6071 18.1758 12.8879 18.875 12 18.875C11.1121 18.875 10.3929 18.1758 10.3929 17.3125V15.4375C10.3929 14.5742 11.1121 13.875 12 13.875C12.8879 13.875 13.6071 14.5742 13.6071 15.4375V17.3125ZM14.8929 10.75H9.10714V7.9375C9.10714 6.38672 10.4049 5.125 12 5.125C13.5951 5.125 14.8929 6.38672 14.8929 7.9375V10.75Z",
    fill: "#1F67C9"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock-alt.5988d293.svg";
export { ForwardRef as ReactComponent };